<template>
  <div class="redact_container">
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      stripe
      border
      v-loading="tableLoading"
    >
      <el-table-column property="carNum" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="carOldNumber" label="老车牌号码">
      </el-table-column>
      <el-table-column property="carNewNumber" label="新车牌号码">
      </el-table-column>
      <el-table-column property="carOldColor" label="老车辆颜色">
      </el-table-column>
      <el-table-column property="carNewColor" label="新车辆颜色">
      </el-table-column>
      <el-table-column property="updateTime" label="注册（变更日期）">
      </el-table-column>
      <el-table-column property="remark" label="备注"> </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false
    };
  },
  components: {
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.$http.getCarNumberList({ id: this.netId }).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/detail/detail_carNumMes.vue